import React from "react";
import { Modal } from "reactstrap";
import "assets/css/safexpay-web.css";
import "./Registration.css";
import Spinner from "reactstrap/lib/Spinner";
import { base_url } from "assets/utils/const";
import {
  nameValidation,
  CompanyNameValidation,
  emailValidation,
} from "assets/utils/constFuntion";
import Navbar from "../Navbars/Navbar-reg";
import { CompanyFieldValidation } from "assets/utils/constFuntion";
import { CompanyPincodeValidation } from "assets/utils/constFuntion";
// import "../StartupPricing/StartupPricing.css";

class RegisterPaymentGateway extends React.Component {
  constructor() {
    super();
    this.state = {
      isAgree: false,
      registerIndia: "Y",
      isLoaded: false,
      firstName: "",
      lastName: "",
      fName: "",
      lName: "",
      email: "",
      companyAdd: "",
      companyName: "",
      companyState: "",
      companyCity: "",
      companyPincode: "",
      isValidEmail: true,
      contactNumber: "",
      isAgreeError: false,
      firstNameError: false,
      lastNameError: false,
      emailError: false,
      companyAddError: false,
      mobileNumberErr: false,
      companyNameError: false,
      countryCodeError: false,
      companyPincodeError: false,
      companyStateError: false,
      companyCityError: false,
    };

    this.toggleState = this.toggleState.bind(this);
  }
  toggleModal = (state) => {
    this.setState({
      [state]: !this.state[state],
    });
  };
  toggleState() {
    this.setState({
      isAgree: !this.state.isAgree,
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();

    const indianMobile = /^(?=.{10}$)[6-9][0-9]{9}$/;
    const nonIndianMobile = /^[0-9]{6,14}$/;
    var umail = event.target.txtEmail.value;
    // const re =
    //   /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!this.handleFistName()) {
      return false;
    }
    if (!this.handleLastName()) {
      return false;
    }

    if (!this.handleEmail()) {
      return false;
    }
    if (!this.handleCompanyName) {
      return false;
    }
    if (!this.handleCompanyAddress()) {
      return false;
    }

    // if (!re.test(umail)) {
    //   this.setState({ isValidEmail: false });
    //   return;
    // } else {
    //   this.setState({ isValidEmail: true });
    // }

    var ufname = event.target.txtFirstName.value;
    var ulname = event.target.txtLastName.value;
    var uIndia = event.target.rdIndia.value;
    var ubaddress = event.target.txtCompanyAddress.value;

    if (uIndia === "Y" && !indianMobile.test(this.state.contactNumber)) {
      this.setState({ mobileNumberErr: true });
      document.getElementById("txtMobile").classList.add("is-invalid");
      window.scrollTo(0, 0);
      return false;
    } else {
      this.setState({ mobileNumberErr: false });
      document.getElementById("txtMobile").classList.remove("is-invalid");
    }
    if (uIndia === "N" && !nonIndianMobile.test(this.state.contactNumber)) {
      this.setState({ mobileNumberErr: true });
      document.getElementById("txtMobile").classList.add("is-invalid");
      window.scrollTo(0, 0);
      return false;
    } else {
      this.setState({ mobileNumberErr: false });
      document.getElementById("txtMobile").classList.remove("is-invalid");
    }

    var umobile = event.target.txtMobile.value;
    var ucode = event.target.txtCCode.value;
    var ucompany = event.target.txtCompanyName.value;

    var ubusiness = event.target.ddlBusinessType.value;
    var lblError = event.target.lblError;
    var isAgree = "N";

    if (
      (uIndia === "Y" && ucode !== "91") ||
      (uIndia === "N" && ucode === "91")
    ) {
      this.setState({ countryCodeError: true });
      return false;
    } else {
      this.setState({ countryCodeError: false });
    }
    // localStorage.setItem("ucompany", ucompany);
    // localStorage.setItem("ubaddress", ubaddress);
    // localStorage.setItem("firstName", ufname);
    // localStorage.setItem("lastName", ulname);

    if (event.target.chkAgreeTC.checked) {
      isAgree = "Y";
    }

    if (!this.state.isAgree) {
      this.setState({
        isAgreeError: true,
      });
      return false;
    } else {
      this.setState({
        isAgreeError: false,
      });
    }
    //alert(temp);
    this.setState({ isLoaded: true });
    // if (uIndia === "N") {
    //   var formdata = new FormData();
    //   formdata.append("grant_type", "password");
    //   formdata.append(
    //     "client_id",
    //     "3MVG9rnryk9FxFMXxKou5iyN_tsBZC5QjdshBWDY3UgivGrUmGS9GAUhrRvbtRiqbEx_yNjDD10WbLjlr5HZV"
    //   );
    //   formdata.append(
    //     "client_secret",
    //     "6774E7E0D54E52152569E354024D4EF1444FF69C71A609542E52EE82442171A8"
    //   );
    //   formdata.append("username", "shreerath@appstrail.com.safexdev");
    //   formdata.append("password", "shree#12345");

    //   var requestOptions = {
    //     method: "POST",
    //     body: formdata,
    //     redirect: "follow",
    //     headers: {
    //       "Access-Control-Allow-Origin": "*",
    //       "Content-Type": "multipart/form-data",
    //     },
    //   };

    //   fetch(
    //     "https://paygateindiapvtltd--devpro.my.salesforce.com/services/oauth2/token",
    //     requestOptions
    //   )
    //     .then((response) => response.text())
    //     .then((result) => {
    //       const accessToken = result.access_token;
    //       fetch(
    //         "https://paygateindiapvtltd--devpro.my.salesforce.com/services/data/v51.0/composite",
    //         {
    //           method: "POST",
    //           headers: {
    //             "Access-Control-Allow-Origin": "*",
    //             "Access-Control-Allow-Methods":
    //               "GET, POST, PATCH, PUT, DELETE, OPTIONS",
    //             "Access-Control-Allow-Headers":
    //               "Origin, Content-Type, X-Auth-Token",
    //             Accept: "application/json",
    //             "Content-Type": "application/json",
    //             Authorization: "Bearer " + accessToken,
    //           },
    //           body: JSON.stringify({
    //             compositeRequest: [
    //               {
    //                 method: "POST",
    //                 url: "/services/data/v51.0/sobjects/Lead",
    //                 referenceId: "newLead",
    //                 body: {
    //                   FirstName: ufname,
    //                   LastName: ulname,
    //                   Email: umail,
    //                   MobilePhone: "+" + ucode + umobile,
    //                   Company: ucompany,
    //                   Street: ubaddress,
    //                   Business_Type__c: ubusiness,
    //                 },
    //               },
    //             ],
    //           }),
    //         }
    //       )
    //         .then((res) => res.json())
    //         .then((result) => {
    //           this.setState({ isLoaded: false });
    //           const status = result.compositeResponse[0].body;
    //           if (status.success) {
    //             window.location.href = "/thankyou";
    //           }
    //         });
    //     })
    //     .catch((error) => {
    //       this.setState({ isLoaded: false });
    //       console.log("error", error);
    //     });

    //   return false;
    // }
    fetch(`${base_url}api/merchantSignUp`, {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods":
          "GET, POST, PATCH, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ag_id: "paygate",
        first_name: ufname,
        last_name: ulname,
        company_address: ubaddress,
        email_id: umail,
        country_code: "+" + ucode,
        Mobile_no: umobile,
        company_name: ucompany,
        city: this.state.companyCity,
        state: this.state.companyState,
        pin_code: this.state.companyPincode,
        Business_type: ubusiness,
        indian_customer: uIndia,
        is_agree: isAgree,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          //alert(result);
          console.log("api result=> ", result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            // localStorage.setItem("umail", umail);
            // localStorage.setItem("umobile", umobile);
            // localStorage.setItem("btype", ubusiness);
            // window.location.href = "/signuplogin";
            if (uIndia == "N") {
              window.location.href = "/thankyou";
            } else {
              window.location.href = "/signuplogin";
            }
          } else {
            if (
              result.payLoad ===
                `Email id already exists ,Please use another email` ||
              result.payLoad == `Email id: ${umail} Already Exists.`
            ) {
              this.toggleModal("loginModal");
            }
            // if (result.payLoad === `First Name: ${ufname} Already Exists`) {
            //   this.setState({ firstName: result.payLoad });
            // }
            // if (result.payLoad === `Last Name: ${ulname} Already Exists`) {
            //   this.setState({ lastName: result.payLoad });
            // }
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          console.log(error);
          // var lblError = document.getElementById("lblError");
          // lblError.classList.remove("d-none");
          // lblError.innerText = error.payLoad;
          //alert('Failed');
          //window.location.href = "/thankyou";
        }
      );
  };

  handleLogin = () => {
    this.toggleModal("loginModal");
    window.location.href = "/login";
  };
  handleFistName = () => {
    this.setState({
      fName:
        this.state.fName.trim().charAt(0).toUpperCase() +
        this.state.fName.trim().slice(1),
    });
    if (!nameValidation(this.state.fName)) {
      this.setState({ firstNameError: true });
      document.getElementById("txtFirstName").classList.add("is-invalid");
      return false;
    } else {
      this.setState({ firstNameError: false });
      document.getElementById("txtFirstName").classList.remove("is-invalid");
      return true;
    }
  };
  handleLastName = () => {
    this.setState({
      lName:
        this.state.lName.trim().charAt(0).toUpperCase() +
        this.state.lName.trim().slice(1),
    });
    if (!nameValidation(this.state.lName)) {
      this.setState({ lastNameError: true });
      document.getElementById("txtLastName").classList.add("is-invalid");
      return false;
    } else {
      this.setState({ lastNameError: false });
      document.getElementById("txtLastName").classList.remove("is-invalid");
      return true;
    }
  };
  handleEmail = () => {
    // this.setState({
    //   email: this.state.email,
    // });
    document.getElementById("txtEmail").value = this.state.email.replace(
      /\s/g,
      ""
    );
    console.log("email", this.state.email);
    if (
      emailValidation(this.state.email) &&
      this.state.email &&
      this.state.email.length < 65
    ) {
      let sp = this.state.email.split("@")[1].split(".");
      if (sp.length > 3) {
        document.getElementById("txtEmail").classList.add("is-invalid");
        this.setState({ isValidEmail: false });
        return false;
      } else {
        document.getElementById("txtEmail").classList.remove("is-invalid");
        this.setState({ isValidEmail: true });
        return true;
      }
    } else {
      document.getElementById("txtEmail").classList.add("is-invalid");
      this.setState({ isValidEmail: false });
      return false;
    }
  };
  handleCompanyAddress = () => {
    this.setState({ companyAdd: this.state.companyAdd.trim() });
    const companyAdd = /^[A-Za-z0-9 .',_//\n-]{1,200}$/;
    if (!companyAdd.test(this.state.companyAdd.trim())) {
      this.setState({ companyAddError: true });
      document.getElementById("txtCompanyAddress").classList.add("is-invalid");
      return false;
    } else {
      this.setState({ companyAddError: false });
      document
        .getElementById("txtCompanyAddress")
        .classList.remove("is-invalid");
      return true;
    }
  };
  handleCompanyName = () => {
    this.setState({ companyName: this.state.companyName.trim() });
    if (!CompanyNameValidation(this.state.companyName.trim())) {
      this.setState({ companyNameError: true });
      document.getElementById("txtCompanyName").classList.add("is-invalid");
      return false;
    } else {
      this.setState({ companyNameError: false });
      document.getElementById("txtCompanyName").classList.remove("is-invalid");
      return true;
    }
  };
  handleCompanyCity = () => {
    this.setState({ companyCity: this.state.companyCity.trim() });
    if (!CompanyFieldValidation(this.state.companyCity.trim())) {
      this.setState({ companyCityError: true });
      document.getElementById("txtCompanyCity").classList.add("is-invalid");
      return false;
    } else {
      this.setState({ companyCityError: false });
      document.getElementById("txtCompanyCity").classList.remove("is-invalid");
      return true;
    }
  };
  handleCompanyState = () => {
    this.setState({ companyState: this.state.companyState.trim() });
    if (!CompanyFieldValidation(this.state.companyState.trim())) {
      this.setState({ companyStateError: true });
      document.getElementById("txtCompanyState").classList.add("is-invalid");
      return false;
    } else {
      this.setState({ companyStateError: false });
      document.getElementById("txtCompanyState").classList.remove("is-invalid");
      return true;
    }
  };
  handleCompanyPincode = () => {
    this.setState({ companyPincode: this.state.companyPincode.trim() });
    if (!CompanyPincodeValidation(this.state.companyPincode.trim())) {
      this.setState({ companyPincodeError: true });
      document.getElementById("txtCompanyPincode").classList.add("is-invalid");
      return false;
    } else {
      this.setState({ companyPincodeError: false });
      document
        .getElementById("txtCompanyPincode")
        .classList.remove("is-invalid");
      return true;
    }
  };
  render() {
    return (
      <>
        <div className="dv-main-registration dv-registration-form register-background">
          <Navbar />
          <main ref="main" className="dv-main dv-login-container">
            <section className="dv-Registration-content">
              <div className="container">
                <div className="row">
                  <div
                    className="col-md-6 dv-instruction"
                    data-aos="fade-right"
                    data-aos-duration="1000"
                  >
                    <h1 className="section-heading">
                      Get Started by Signing Up
                    </h1>
                    <ul className="tick" style={{ paddingLeft: "10px" }}>
                      <li>Accept Payments from Anywhere Anytime</li>
                      <li>Instant Money Transfer</li>
                      <li>Set Up your own Payments Platform</li>
                    </ul>
                    <div
                      className="dv-allPaymentMethods row mx-0"
                      data-aos="fade-down"
                      data-aos-duration="1000"
                      id="dv-allPaymentMethods"
                    >
                      <div style={{ width: "100%" }}>
                        <h2
                          className="section-heading"
                          style={{ paddingLeft: "0" }}
                        >
                          Accept Payments
                        </h2>
                        {/* <div
                          className="dv-percentage"
                          style={{ marginTop: "0px" }}
                        >
                          <label
                            style={{ position: "relative", fontSize: "2rem" }}
                          >
                            @ <span className="line-throughs">1.65%</span> 1.49%
                            <sup
                              style={{
                                position: "absolute",
                                top: "22px",
                              }}
                            >
                              *
                            </sup>{" "}
                            <span className="ml-2">TDR</span>
                          </label>
                        </div> */}
                        {/* <h4 style={{ color: "#fff" }}>
                          Offer Valid till 31st Dec'2021
                        </h4> */}

                        <ul className="tick">
                          <li>Seamless Onboarding</li>
                          <li>50+ Currencies</li>
                          <li>Developer Friendly APIs</li>
                          <li>Fast Settlements</li>
                        </ul>
                      </div>
                      <div style={{ width: "100%" }}>
                        <h2
                          className="section-heading"
                          style={{ paddingLeft: "0" }}
                        >
                          100+ Payment Modes Including:
                        </h2>
                        <ul className="tick">
                          <li>Net Banking With all Major Banks.</li>
                          <li>Accepting Indian Debit & Credit Cards.</li>
                          <li>
                            UPI Payments with Google Pay, PhonePe, Paytm, BHIM &
                            more
                          </li>
                          <li>
                            E-Wallets like Amazon Pay, Freecharge, Mobikwik, &
                            more
                          </li>
                        </ul>
                      </div>
                      <div className="col-12 dv-facility rounded-border-box">
                        <ul className="ul-facility row mx-0">
                          <li className="col-3">No Setup Fees</li>
                          <li className="col-4">No Maintainance Fees</li>
                          <li className="col-4">No Hidden Fees</li>
                        </ul>
                      </div>
                      <div className="col-12 dv-note ">
                        (+) Subject to approval from banking partners.
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-md-6"
                    data-aos="fade-up"
                    data-aos-duration="1000"
                  >
                    <form
                      onSubmit={this.handleSubmit}
                      className="dv-registration-form dv-form"
                    >
                      <h1 className="section-heading border-heading">
                        Sign Up
                      </h1>
                      <div className="form-group">
                        <label htmlFor="txtFirstName">
                          First Name <span className="req">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="txtFirstName"
                          id="txtFirstName"
                          required
                          placeholder="Eg. Rahul"
                          value={this.state.fName}
                          onChange={(e) =>
                            this.setState({
                              fName: e.target.value,
                              firstName: "",
                            })
                          }
                          onBlur={this.handleFistName}
                        />
                        {/* <small style={{ color: "red" }}>
                      {this.state.firstName}
                    </small> */}
                        {this.state.fName.length > 20 && (
                          <div>
                            <small style={{ color: "red" }}>
                              First name length should be less than 20
                              characters.
                            </small>
                          </div>
                        )}
                        {this.state.firstNameError && (
                          <small style={{ color: "red" }}>
                            Invalid first name.
                          </small>
                        )}
                      </div>
                      <div className="form-group">
                        <label htmlFor="txtLastName">
                          Last Name <span className="req">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="txtLastName"
                          id="txtLastName"
                          required
                          placeholder="Eg. Kumar"
                          value={this.state.lName}
                          onChange={(e) =>
                            this.setState({
                              lName: e.target.value,
                              lastName: "",
                            })
                          }
                          onBlur={this.handleLastName}
                        />
                        {/* <small style={{ color: "red" }}>
                      {this.state.lastName}
                    </small> */}
                        {this.state.lName.length > 20 && (
                          <div>
                            <small style={{ color: "red" }}>
                              Last name length should be less than 20
                              characters.
                            </small>
                          </div>
                        )}
                        {this.state.lastNameError && (
                          <small style={{ color: "red" }}>
                            Invalid last name.
                          </small>
                        )}
                      </div>
                      <div className="form-group">
                        <label htmlFor="txtEmail">
                          Email Address <span className="req">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="txtEmail"
                          id="txtEmail"
                          required
                          placeholder="Eg. rahul@example.com"
                          value={this.state.email}
                          onChange={(e) =>
                            this.setState({
                              email: e.target.value.replace(/\s/g, ""),
                            })
                          }
                          onBlur={this.handleEmail}
                        />
                        {!this.state.isValidEmail && (
                          <small className="err">
                            Please Enter a valid email
                          </small>
                        )}
                      </div>
                      <div
                        className="form-row mb-0"
                        style={{ alignItems: "baseline" }}
                      >
                        <div className="form-group col-4">
                          <label htmlFor="txtCCode">
                            Country Code <span className="req">*</span>
                          </label>
                          <div className="input-group">
                            <div className="input-group-prepend">
                              <span
                                className="input-group-text"
                                id="validationTooltipUsernamePrepend"
                              >
                                +
                              </span>
                            </div>
                            <input
                              type="number"
                              className="form-control"
                              maxLength="5"
                              name="txtCCode"
                              id="txtCCode"
                              required
                              placeholder="91"
                              defaultValue="91"
                            />
                          </div>
                          {this.state.countryCodeError && (
                            <small className="err">Invalid country code.</small>
                          )}
                        </div>

                        <div className="form-group col-8">
                          <label htmlFor="txtMobile">
                            Mobile Number <span className="req">*</span>
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            maxLength={10}
                            name="txtMobile"
                            id="txtMobile"
                            required
                            placeholder="9876543210"
                            value={this.state.contactNumber}
                            onChange={(e) =>
                              this.setState({ contactNumber: e.target.value })
                            }
                          />
                          {this.state.mobileNumberErr && (
                            <small style={{ color: "red" }}>
                              Invalid mobile number.
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="form-group">
                        <label htmlFor="txtCompanyName">
                          Company Name <span className="req">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="txtCompanyName"
                          id="txtCompanyName"
                          required
                          placeholder="Eg. Safexpay"
                          value={this.state.companyName}
                          onChange={(e) =>
                            this.setState({ companyName: e.target.value })
                          }
                          onBlur={this.handleCompanyName}
                        />
                        {this.state.companyName.length > 150 && (
                          <div>
                            <small style={{ color: "red" }}>
                              Company name length should be less than 150
                              characters.
                            </small>
                          </div>
                        )}
                        {this.state.companyNameError && (
                          <div>
                            <small style={{ color: "red" }}>
                              Invalid company name.
                            </small>
                          </div>
                        )}
                      </div>
                      <div className="form-group mt-md-2">
                        <label htmlFor="txtCompanyAddress">
                          Company Address <span className="req">*</span>
                        </label>
                        <textarea
                          type="text"
                          className="form-control"
                          name="txtCompanyAddress"
                          id="txtCompanyAddress"
                          required
                          placeholder="Enter Full Address"
                          value={this.state.companyAdd}
                          onChange={(e) =>
                            this.setState({ companyAdd: e.target.value })
                          }
                          onBlur={this.handleCompanyAddress}
                        ></textarea>
                        <small className="">Max length: 200 characters.</small>
                        {this.state.companyAdd.length > 200 && (
                          <div>
                            <small className="err">
                              Address length should be less than 200 characters.
                            </small>
                          </div>
                        )}
                        {this.state.companyAddError && (
                          <div>
                            <small className="err">
                              Invalid company address.
                            </small>
                          </div>
                        )}
                      </div>
                      <div className="form-group">
                        <label htmlFor="txtCompanyCity">
                          Company City <span className="req">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="txtCompanyCity"
                          id="txtCompanyCity"
                          required
                          placeholder="Eg. Gurugram"
                          value={this.state.companyCity}
                          onChange={(e) =>
                            this.setState({ companyCity: e.target.value })
                          }
                          onBlur={this.handleCompanyCity}
                        />
                        {this.state.companyCityError && (
                          <div>
                            <small style={{ color: "red" }}>
                              Invalid company city name.
                            </small>
                          </div>
                        )}
                      </div>
                      <div className="form-group">
                        <label htmlFor="txtCompanyState">
                          Company State <span className="req">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="txtCompanyState"
                          id="txtCompanyState"
                          required
                          placeholder="Eg. Haryana"
                          value={this.state.companyState}
                          onChange={(e) =>
                            this.setState({ companyState: e.target.value })
                          }
                          onBlur={this.handleCompanyState}
                        />
                        {this.state.companyStateError && (
                          <div>
                            <small style={{ color: "red" }}>
                              Invalid company state.
                            </small>
                          </div>
                        )}
                      </div>
                      <div className="form-group">
                        <label htmlFor="txtCompanyPincode">
                          Company Pincode <span className="req">*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="txtCompanyPincode"
                          id="txtCompanyPincode"
                          required
                          placeholder="Eg. 122001"
                          value={this.state.companyPincode}
                          onChange={(e) =>
                            this.setState({ companyPincode: e.target.value })
                          }
                          onBlur={this.handleCompanyPincode}
                        />
                        {this.state.companyPincodeError && (
                          <div>
                            <small style={{ color: "red" }}>
                              Invalid Pincode.
                            </small>
                          </div>
                        )}
                      </div>
                      <div className="form-group sel-cust">
                        <label htmlFor="ddlBusinessType">
                          Business Type <span className="req">*</span>
                        </label>
                        <select
                          className="custom-select"
                          name="ddlBusinessType"
                          id="ddlBusinessType"
                          required
                        >
                          <option value="">Please select</option>
                          <option value="Individual">Individual</option>
                          <option value="Proprietorship">Proprietorship</option>
                          <option value="Partnership/LLP">
                            Partnership / LLP
                          </option>
                          <option value="PrivateLtd./PublicLtd.">
                            Private Ltd. / Public Ltd.
                          </option>
                          <option value="Trust/Society">Trust/ Society</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label className="d-block" htmlFor="rdIndia">
                          Is your business registered in India?
                          <span className="red">*</span>
                        </label>
                        <div className="custom-control custom-radio custom-control-inline my-3">
                          <input
                            type="radio"
                            id="rdIndia1"
                            name="rdIndia"
                            value="Y"
                            className="custom-control-input"
                            onChange={(e) =>
                              this.setState({ registerIndia: e.target.value })
                            }
                            checked={this.state.registerIndia === "Y"}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="rdIndia1"
                          >
                            Yes
                          </label>
                        </div>
                        <div className="custom-control custom-radio custom-control-inline">
                          <input
                            type="radio"
                            id="rdIndia2"
                            name="rdIndia"
                            value="N"
                            className="custom-control-input"
                            onChange={(e) =>
                              this.setState({ registerIndia: e.target.value })
                            }
                            checked={this.state.registerIndia === "N"}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="rdIndia2"
                          >
                            No
                          </label>
                        </div>
                      </div>
                      <div className="form-group form-check text-center my-4">
                        <input
                          onChange={this.toggleState}
                          type="checkbox"
                          className="form-check-input"
                          name="chkAgreeTC"
                          id="chkAgreeTC"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="chkAgreeTC"
                          style={{ marginTop: "1px" }}
                        >
                          I agree to{" "}
                          <a
                            href="/company/terms-conditions"
                            className="text-underline"
                            target="_blank"
                          >
                            Terms and Conditions*
                          </a>
                        </label>
                      </div>
                      {this.state.isAgreeError && (
                        <p className="alert-danger" style={{ color: "#fff" }}>
                          Please accept terms & conditions
                        </p>
                      )}
                      <div
                        className="dv-error alert alert-danger d-none"
                        role="alert"
                        id="lblError"
                        name="lblError"
                      ></div>
                      <div className="btn-holder text-center">
                        <button
                          type="submit"
                          id="btn-create-account"
                          name="btn-create-account"
                          className={
                            this.state.isLoaded
                              ? `btn btn-create-account btn-gradient disable-btn`
                              : `btn btn-create-account btn-gradient`
                          }
                          disabled={this.state.isLoaded}
                        >
                          Create Account
                          {this.state.isLoaded ? (
                            <Spinner
                              size="sm"
                              color="light"
                              className="btn-loader"
                            />
                          ) : null}
                        </button>
                      </div>
                      <p className="text-center my-4">
                        <a
                          href="/login"
                          className="btn btn-link text-underline"
                        >
                          Already a registered user?
                        </a>
                      </p>
                      <div className="dv-bottom-bg">
                        <div className="first-bottom-bg"></div>
                        <div className="second-bottom-bg"></div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <Modal
                className="modal-dialog-centered modal-lg loginModal"
                isOpen={this.state.loginModal}
                toggle={() => this.toggleModal("loginModal")}
                backdrop={false}
                keyboard={false}
              >
                <div className="modal-body p-4">
                  {/* <button
                aria-label="Close"
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => this.toggleModal("loginModal")}
              >
                <span aria-hidden={true} className="close-btn-align">
                  ×
                </span>
              </button> */}
                  <h5 style={{ textAlign: "center" }}>
                    Email already exists, please Login to continue.
                  </h5>
                  <div className="btn-holder mt-3 text-center">
                    <button
                      onClick={this.handleLogin}
                      className="btn btn-gradient bt-wd"
                    >
                      Login
                    </button>
                  </div>
                </div>
              </Modal>
            </section>
          </main>
        </div>
      </>
    );
  }
}

export default RegisterPaymentGateway;
